import { useState, useEffect } from 'react';
import { subscribeMissionToSidebar } from '../../../utils/missionToSidebarBridge';

/**
 * Subscribes to mission→sidebar drag bridge for drop-target highlighting.
 */
export function useSidebarMissionDrop() {
  const [missionDropTargetSprintId, setMissionDropTargetSprintId] = useState(null);

  useEffect(() => {
    return subscribeMissionToSidebar((bridgeState) => {
      setMissionDropTargetSprintId(
        bridgeState.active ? bridgeState.hoverTargetSprintId : null,
      );
    });
  }, []);

  return { missionDropTargetSprintId };
}

export default useSidebarMissionDrop;
